import { type VariantProps, cva } from 'class-variance-authority'

import { cn } from '@/lib/ui/style-helpers'

const statCardVariants = cva('rounded-md flex flex-col justify-center gap-0 border p-3', {
  variants: {
    variant: {
      success: 'text-main-foreground-success',
      warning: 'text-main-foreground-warning',
      danger: 'text-main-foreground-danger',
    },
  },
})

export type StatCardProps = VariantProps<typeof statCardVariants> & {
  count: number
  label: string
}

export const StatCard = ({ count, label, variant }: StatCardProps) => {
  return (
    <div className={cn(statCardVariants({ variant }))}>
      <div className='flex items-center gap-2 text-body-default'>
        <span className='font-bold'>{count}</span>
        <span className='text-nowrap font-medium'>{label}</span>
      </div>
    </div>
  )
}
